import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import { API_BASE_URL } from "../../../const";
import ScreenCaption from '../../screen-caption.js';
import del from '../../../img/del.svg';

export default class EventDocsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args;

        this.state = {
            args: args,
            eventid: args.eventid,
            event: args.event,
            docs: [],
            selectedDoc: null,
            loading: false,
            uploading: false,
            error: null,
            dragOver: false
        };

        this.fileInputRef = React.createRef();

        this.loadDocs = this.loadDocs.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this.handleFileInput = this.handleFileInput.bind(this);
        this.openFileDialog = this.openFileDialog.bind(this);
        this.deleteDoc = this.deleteDoc.bind(this);
        this.downloadAllDocs = this.downloadAllDocs.bind(this);
        this.createMobileUploadLink = this.createMobileUploadLink.bind(this);

    }

    componentDidMount() {
        this.loadDocs();
    }

    authHeaders() {
        return {
            'SESSIONID': sessionStorage.getItem("session")
        };
    }

    async loadDocs() {
        if (!this.state.eventid) {
            this.setState({ error: "Не задано событие" });
            return;
        }

        this.setState({ loading: true, error: null });

        BaseApi.get("/event/docs", {
            headers: this.authHeaders(),
            params: { eventid: this.state.eventid },
            withCredentials: true
        })
        .then(res => {
            const docs = res.data || [];
            this.setState({
                docs: docs,
                selectedDoc: docs.length > 0 ? docs[0] : null,
                loading: false
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({
                loading: false,
                error: "Не удалось загрузить документы"
            });
        });
    }

    handleFileInput(event) {
        this.handleFiles(event.target.files);
        event.target.value = "";
    }

   async handleFiles(fileList) {
        const files = Array.from(fileList || []);

        console.log(`CAV ${files.length}`)

        const docFiles = files.filter(file =>
            file.type === "application/pdf"
        );

        if (docFiles.length === 0) {
            this.setState({ error: "Можно загрузить только PDF-документы" });
            return;
        }

        this.setState({ uploading: true, error: null });

        try {
           
            const formData = new FormData();
            formData.append("eventid", this.state.eventid);

            docFiles.forEach(file => {
                formData.append("files[]", file);
            });

            await BaseApi.post("/event/doc", formData, {
                headers: {
                    ...this.authHeaders()
                },
                withCredentials: true
            });

            this.setState({ uploading: false });
            this.loadDocs();

        } catch (error) {
            console.log(error);
            this.setState({
                uploading: false,
                error: "Не удалось подготовить или загрузить документы"
            });
        }
    }

    openFileDialog() {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    }


    deleteDoc(doc) {
        if (!doc || !doc.id) {
            return;
        }

        BaseApi.delete("/event/doc", {
            headers: this.authHeaders(),
            params: { id: doc.id },
            withCredentials: true
        })
        .then(() => {
            const docs = this.state.docs.filter(p => p.id !== doc.id);
            const selectedDoc =
                this.state.selectedDoc && this.state.selectedDoc.id === doc.id
                    ? (docs.length > 0 ? docs[0] : null)
                    : this.state.selectedDoc;

            this.setState({
                docs: docs,
                selectedDoc: selectedDoc
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({ error: "Не удалось удалить документы" });
        });
    }

    async downloadAllDocs() {
        if (!this.state.eventid) {
            this.setState({ error: "Не задано событие" });
            return;
        }

        this.setState({ error: null });

        try {
            const response = await BaseApi.get("/event/doc/archive", {
                headers: this.authHeaders(),
                params: { eventid: this.state.eventid },
                withCredentials: true,
                responseType: "blob"
            });

            const blob = new Blob([response.data], { type: "application/zip" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `event-photos-${this.state.eventid}.zip`;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
            this.setState({ error: "Не удалось скачать архив документов" });
        }
    }

    async createMobileUploadLink() {
        if (!this.state.eventid) {
            this.setState({ error: "Не задано событие" });
            return;
        }

        this.setState({
            mobileUploadLoading: true,
            mobileUploadCopied: false,
            error: null
        });

        try {
            const response = await BaseApi.post("/event/doc/mobile-upload-token", null, {
                headers: this.authHeaders(),
                params: { eventid: this.state.eventid },
                withCredentials: true
            });


            const relativeUrl = response.data.result.url        

            const mobileUploadUrl = relativeUrl.startsWith("http")
                ? relativeUrl
                : `${window.location.origin}${relativeUrl}`;

            this.setState({
                mobileUploadUrl,
                mobileUploadLoading: false
            });

            if (navigator.clipboard) {
                await navigator.clipboard.writeText(mobileUploadUrl);
                this.setState({ mobileUploadCopied: true });
            }

        } catch (error) {
            console.log(error);
            this.setState({
                mobileUploadLoading: false,
                error: "Не удалось создать ссылку для загрузки с телефона"
            });
        }
    }

    renderUploadZone() {
        return (
            <div
                className={
                    "border rounded p-3 mb-3 text-center " +
                    (this.state.dragOver ? "border-primary bg-light" : "border-secondary")
                }
                onDragOver={(e) => {
                    e.preventDefault();
                    this.setState({ dragOver: true });
                }}
                onDragLeave={(e) => {
                    e.preventDefault();
                    this.setState({ dragOver: false });
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    this.setState({ dragOver: false });
                    this.handleFiles(e.dataTransfer.files);
                }}
            >
                <input
                    ref={this.fileInputRef}
                    type="file"
                    accept="application/pdf"
                    multiple
                    className="d-none"
                    onChange={this.handleFileInput}
                />

                <div className="mb-2">
                    Перетащите PDF документы сюда
                </div>

                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={this.openFileDialog}
                    disabled={this.state.uploading}
                >
                    Выбрать документы
                </button>

                {this.state.uploading && (
                    <div className="mt-2 text-muted">
                        Загрузка...
                    </div>
                )}
            </div>
        );
    }

    render() {
        const selected = this.state.selectedDoc;

        return (
            <div className="container">
                <ScreenCaption
                    goback={this.props.goback}
                    args={this.props.args}
                    caption={"Документы"}
                />

                <div className="row mt-4">
                    <div className="col-12">
                        {this.renderUploadZone()}

                        <div className="d-flex justify-content-end mb-3">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={this.downloadAllDocs}
                                disabled={this.state.loading || this.state.docs.length === 0}
                            >
                                Скачать все документы
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={this.createMobileUploadLink}
                                disabled={this.state.mobileUploadLoading}
                            >
                                {this.state.mobileUploadLoading
                                    ? "Создание ссылки..."
                                    : "Ссылка для загрузки с телефона"}
                            </button>
                        </div>

                        {this.state.mobileUploadUrl && (
                            <div className="alert alert-info">
                                <div className="mb-2">
                                    Ссылка для загрузки документов с телефона:
                                </div>

                                <a
                                    href={this.state.mobileUploadUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        overflowWrap: "anywhere"
                                    }}
                                >
                                    {this.state.mobileUploadUrl}
                                </a>

                                {this.state.mobileUploadCopied && (
                                    <div className="small text-muted mt-2">
                                        Ссылка скопирована в буфер обмена
                                    </div>
                                )}
                            </div>
                        )}

                        

                        {this.state.error && (
                            <div className="alert alert-danger">
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </div>

                {this.state.loading && (
                    <div className="text-muted">
                        Загрузка фотографий...
                    </div>
                )}

                {!this.state.loading && this.state.docs.length === 0 && (
                    <div className="card shadow-sm">
                        <div className="card-body text-muted">
                            Документы пока не загружены.
                        </div>
                    </div>
                )}

                {!this.state.loading && this.state.docs.length > 0 && (
                    <div className="row">
                        <div className="col-lg-9 mb-3">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    {selected && (
                                        <div>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="text-muted small">
                                                    {selected.originalName || selected.name || "Документ"}
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => this.deleteDoc(selected)}
                                                >
                                                    <img
                                                        src={del}
                                                        alt=""
                                                        style={{ width: "16px", height: "16px", marginRight: "6px" }}
                                                    />
                                                    Удалить
                                                </button>
                                            </div>

                                           <iframe
                                                src={API_BASE_URL+selected.url}
                                                alt={selected.originalName || "Документ"}
                                                className="img-fluid rounded"
                                                style={{
                                                    width: "100%",
                                                    height: "70vh",
                                                    objectFit: "contain",
                                                    background: "#f8f9fa"
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div
                                className="card shadow-sm"
                                style={{
                                    maxHeight: "75vh",
                                    overflowY: "auto"
                                }}
                            >
                                <div className="card-body">
                                    <h6 className="card-title mb-3">
                                        Документы
                                    </h6>

                                   {this.state.docs.map(doc => {
                                        const active =
                                            this.state.selectedDoc &&
                                            this.state.selectedDoc.id === doc.id;

                                        return (
                                            <button
                                                key={doc.id}
                                                type="button"
                                                className={
                                                    "btn p-2 mb-2 w-100 text-start " +
                                                    (active ? "border border-primary" : "border")
                                                }
                                                onClick={() => this.setState({ selectedDoc: doc })}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <div
                                                        className="d-flex align-items-center justify-content-center me-2"
                                                        style={{
                                                            width: "48px",
                                                            height: "48px",
                                                            background: "#dc3545",
                                                            color: "white",
                                                            borderRadius: "8px",
                                                            fontWeight: "bold",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        PDF
                                                    </div>

                                                    <div
                                                        style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            {doc.originalName || "Документ"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/event-docs.js